<mat-form-field class="w-full" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    type="text"
    matInput
    uppercase
    [formControl]="ufController"
    [matAutocomplete]="auto"
    [required]="required"
    placeholder="Digite para buscar"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="showUfMode === 'ufSigla' ? displaySiglaFn : displayNameFn"
    (optionSelected)="handleChange($event.option.value)"
  >
    <mat-option *ngFor="let uf of filteredUfs | async" [value]="uf">
      {{ uf.nome }}/{{ uf.sigla }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
